import React, {useEffect, useState} from 'react';
import Form, { Actions, EmailAddressValidator, Password, RequiredValidator, TextField } from '../../Components/Form';
import Card from '../../Components/Containers/Card';
import { Link, useParams } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import Icon from '../../Components/Icons/Icon';
import { useToasts } from '../../Components/Toasts';
import API from '../../Services/API';
import Loading from '../../Components/Loading';
import Recaptcha from '../../Services/Recaptcha';
import TagManager from '../../Components/Analytics/TagManager';

const Login = () => {
    const {code} = useParams();
    const {showError} = useToasts();
    const {login} = useSession();
    const [voucherLocked, setVoucherLocked] = useState(!!code);
    const [registering, setRegistering] = useState(false);

    const register = async (data) => {
        try {
            const captchaToken = await Recaptcha.getToken('register');
            data.captchaToken = captchaToken;

            return API.post('/users/register', data)
                .then((res) => {
                    waitForRegistrationComplete(res.userId, {email: data.email, password: data.password});
                })
                .catch(err => {
                    showError(API.parseErrorResponse(err));
                })
        } catch (err) {
            showError(API.parseErrorResponse(err));
        }
    }

    const waitForRegistrationComplete = (userId, credentials) => {
        setRegistering(true);

        API.get('/users/waitForRegistration?userId=' + userId).then(() => {
            login(credentials)
        }).catch(err => {
            showError(API.parseErrorResponse(err))
        })
    }

    useEffect(() => {
        Recaptcha.init();
    }, []);

    return <>
        <img src="/logo-name-horizontal.png"
            alt="getSoapy Logo"
            width="888"
            height="183"
            className="w-[75%] h-auto mx-auto mb-8"
        />

        <Card>
            {registering ? <Registering /> : <RegisterForm {...{code, register, voucherLocked, setVoucherLocked}} />}
        </Card>

        {!registering && <p className="text-center mt-4 text-muted text-sm">
            Already registered? <Link to="/login" className="link">Login here.</Link>
        </p>}

        <TagManager />
    </>;
}

const RegisterForm = ({code, register, voucherLocked, setVoucherLocked}) => {
    return <Form data={{voucherCode: code}} onSubmit={register}>
        <TextField type="email" name="email" label="Email" validators={[RequiredValidator, EmailAddressValidator]} />
        <Password label="Password" name="password" validators={[RequiredValidator]} showPrompts />
        <TextField label="Voucher code"
            name="voucherCode"
            validators={[]}
            disabled={voucherLocked}
            suffixOnClick={() => setVoucherLocked(false)}
            suffix={voucherLocked ? <Icon icon="Pencil" /> : null}
        />
        <Actions submit={{label: 'Register'}} />
    </Form>
}

const Registering = () => {
    return <div className="my-4">
        <Loading size="2x" center />
        <p className="text-center text-muted text-sm mt-4">
            Creating your account
        </p>
    </div>
}

export default Login;
